// Copyright (C) 2018-2024 Skylark Drones

export default {
  setUserResponse({ commit }, payload) {
    commit('updateUser', payload)
  },

  setPreferences({ commit }, preferences) {
    commit('updateFilters', preferences.filters)
    commit('setGroupByType', preferences.group)
    commit('setViewMode', preferences.view)
  }
}
